const en = {
  totalScore: 'Score:',
  send: 'Send',
  leaveComment: 'Leave a comment for',
  recommended: 'Recommended',
  yes: 'Yes',
  no: 'No',
  seeCommentsTitle: 'See comments',
  leaveCommentLabel: 'Leave a comment',
  openLibItem: 'Open library item',
  recommendPlaybooks: 'Recommend Playbooks',
  noPlaybooksFound: 'No recommendations found',
  stopIt: 'Stop it',
  paused: 'Paused',
  complete: 'Complete',
  startTextToSpeech: 'Read aloud',
  playTextToSpeech: 'Play',
  pauseTextToSpeech: 'Pause',
  copyToClipboard: 'Copy to clipboard',
  crmObjectCreationSuccess: '%crmObject% has been created.',
  newCrmObjectCreationConfirm: 'Another CRM object has already been created. Click again to create a new one.',
  crmObjectCreationError: 'Error while creating %crmObject%',
  navigateToCrmObject: 'Reveal in new tab',
  playIdNotDetermined: 'Play context could not be determined',
  aiDisclaimer_mayContainMistakes: 'AI-generated content may contain mistakes.',
  aiDisclaimer_report: 'Report an issue',
  aiDisclaimer_reportHint:
    'If you have encountered any inappropriate, harmful, or offensive content, please report it to',
  aiDisclaimer_close: 'Close',
  uploadFile: 'Upload file',
  noFilesUploaded: 'No files uploaded yet',
  genericAiWidget_undoTooltip: 'Undo',
  genericAiWidget_copyTooltip: 'Copy',
  connectToTitle: 'Connect to $',
  cancelLabel: 'Cancel',
  proceedLabel: 'Proceed',
  connectCrmWidgetEstablishText: 'Teammate will now establish connection with your CRM',
  connectCrmWidgetPlannedActions: 'Planned actions',
  connectCrmWidgetNotFound:
    'Match not found in CRM. If matching {type} exists, please connect to this Play manually before proceeding.',
  company: 'company',
  contact: 'contact',
  opportunity: 'opportunity',
  connectCrmWidgetMatchFound: 'Match found in CRM',
  create: 'Create',
  sync: 'Sync',
  findObjectsErrorStatus: 'Could not find some of the referenced objects. Please check the Web-links in your Play',
  handleObjectsErrorStatus: 'Could not connect to CRM. Please check your data',
  connectedToCrm: 'Connected to CRM',
  disconnectFromCrm: 'disconnect',
  freeTextPlaceholder: 'Type your answer here...',
  scrollDown: 'Scroll down',
  establishCrmConnection: 'Click here to establish the CRM connection',
  reEstablishCrmConnection: 'Click here to restore the CRM connection',
  questionRequiredLabel: 'Required to fill out',
  assessmentRequiredLabel: 'Choose responses below',
  assessmentHideUnselectedOptions: 'Hide unselected options',
  assessmentShowHiddenOption: 'Show {count} hidden option',
  assessmentShowHiddenOptions: 'Show {count} hidden options',
  noSectionsAdded: 'Sections are not added',
  noPinnedSections: 'No visible pinned sections',
  allSectionsPinned: 'All sections of the header pinned or conditionally hidden',
  aiTeammateWidget_defaultButton: 'Start AI Teammate',
  aiTeammateWidget_starting: 'Starting...',
  aiTeammateWidget_stopListening: 'Stop Listening',
  aiTeammateWidget_listening: 'Listening...',
  aiTeammateWidget_headerListening: 'Listening',
  aiTeammateWidget_extractedInformation: 'Extracted information:',
  aiTeammateWidget_noAnswer: 'No answer',
  aiTeammateWidget_uncertain: '(uncertain)',
  aiTeammateWidget_uncertain_ignored: '(ignored: too uncertain)',
  aiTeammateWidget_option: 'Option',
  aiTeammateWidget_timeoutReached: 'Safety timeout reached. Listening stopped automatically.',
  aiTeammateWidget_audioUnavailable: 'Audio stream is no longer available.',
  aiTeammateWidget_connectionLost: 'Connection lost. Please check your network and start AI Teammate again.',
  aiTeammateWidget_clearLog: 'Clear log',
  aiTeammateWidget_question: 'Question',
  aiTeammateWidget_appConnected: 'App connected',
  aiTeammateWidget_transcript: 'Transcript',
  aiTeammateWidget_noTranscript: 'No transcript yet...',
  emailValidationError: 'Invalid email address',
  addSectionsText: 'Add sections to organize your playbook',
  dropdownPlaceholder: 'Choose an option',
  dropdownNoItemsFound: 'No items found.',
  clear: 'Clear',
  formula_error_syntax: 'Incomplete or invalid formula structure (operators/brackets).',
  formula_error_missing_var: 'The formula references variables that are no longer available.',
  formula_error_empty: 'No formula defined.',
  formula_error_unknown: 'An error occurred during calculation.',
  codeSnippetWidget_defaultButton: 'Code Snippet',
  createCrmObjectWidget_defaultButton: 'Create',
  genericAiWidget_defaultButton: 'Generate',
  setTagWidget_defaultButton: 'Next',
  updateWithAiWidget_defaultButton: 'Update',
  chartNotSupportedMessage: "This Action Cards doesn't support scoring dimensions to display a chart",
  chartTotalScoreLabel: 'Weighted score',
  lastSlideTitle: 'End',
}

const de = {
  totalScore: 'Score:',
  recommended: 'Empfohlen',
  leaveComment: 'Hinterlassen Sie einen Kommentar für',
  send: 'Schicken',
  yes: 'Ja',
  no: 'Nein',
  seeCommentsTitle: 'Zeige Kommentare',
  leaveCommentLabel: 'Hinterlasse einen Kommentar',
  openLibItem: 'Library item öffnen',
  recommendPlaybooks: 'Playbooks empfehlen',
  noPlaybooksFound: 'Keine Empfehlungen gefunden',
  stopIt: 'Hör auf damit',
  paused: 'Angehalten',
  complete: 'Vollständig',
  startTextToSpeech: 'Laut vorlesen',
  playTextToSpeech: 'Abspielen',
  pauseTextToSpeech: 'Pause',
  copyToClipboard: 'In die Zwischenablage kopieren',
  crmObjectCreationSuccess: '%crmObject% wurde erstellt.',
  newCrmObjectCreationConfirm:
    'Es wurde bereits ein CRM-Objekt erstellt. Klicken Sie erneut, um ein weiteres zu erstellen.',
  crmObjectCreationError: 'Fehler beim Erstellen von %crmObject%',
  navigateToCrmObject: 'In neuem Tab anzeigen',
  playIdNotDetermined: 'Play kontext konnte nicht ermittelt werden',
  aiDisclaimer_mayContainMistakes: 'KI-generierte Inhalte können Fehler enthalten.',
  aiDisclaimer_report: 'Problem Melden',
  aiDisclaimer_reportHint:
    'Wenn Sie auf unangemessene, schädliche oder beleidigende Inhalte gestoßen sind, melden Sie diese bitte an',
  aiDisclaimer_close: 'Schließen',
  uploadFile: 'Datei hochladen',
  noFilesUploaded: 'Noch keine Dateien hochgeladen',
  genericAiWidget_undoTooltip: 'Rückgängig',
  genericAiWidget_copyTooltip: 'Kopieren',
  connectToTitle: 'Mit dem $ verbinden',
  cancelLabel: 'Stornieren',
  proceedLabel: 'Fortfahren',
  connectCrmWidgetEstablishText: 'Teammate stellt jetzt eine Verbindung mit Ihrem CRM her',
  connectCrmWidgetPlannedActions: 'Geplante Aktionen',
  connectCrmWidgetNotFound:
    'Keine Übereinstimmung im CRM gefunden. Falls eine Übereinstimmung mit {type} vorhanden ist, stellen Sie bitte manuell eine Verbindung zu diesem Spiel her, bevor Sie fortfahren.',
  company: 'Unternehmen',
  contact: 'Kontakt',
  opportunity: 'Gelegenheit',
  connectCrmWidgetMatchFound: 'Übereinstimmung im CRM gefunden',
  create: 'Erstellen',
  sync: 'Synch',
  findObjectsErrorStatus:
    'Einige der referenzierten Objekte konnten nicht gefunden werden. Bitte überprüfen Sie die Web-Links in Ihrem Play',
  handleObjectsErrorStatus: 'Konnte nicht mit CRM verbinden. Bitte überprüfen Sie Ihre Daten',
  connectedToCrm: 'Mit CRM verbunden',
  disconnectFromCrm: 'trennen',
  freeTextPlaceholder: 'Geben Sie hier Ihre Antwort ein...',
  scrollDown: 'Nach unten scrollen',
  establishCrmConnection: 'Klicken Sie hier, um die CRM-Verbindung herzustellen',
  reEstablishCrmConnection: 'Klicken Sie hier, um die CRM-Verbindung wiederherzustellen',
  questionRequiredLabel: 'Zum Ausfüllen erforderlich',
  assessmentRequiredLabel: 'Bitte wählen Sie eine Antwort',
  assessmentHideUnselectedOptions: 'Nicht ausgewählte Optionen ausblenden',
  assessmentShowHiddenOption: '{count} ausgeblendete Option anzeigen',
  assessmentShowHiddenOptions: '{count} ausgeblendete Optionen anzeigen',
  noSectionsAdded: 'Abschnitte werden nicht hinzugefügt',
  noPinnedSections: 'Keine sichtbaren fixierten Abschnitte',
  allSectionsPinned: 'Alle Abschnitte der Kopfzeile fixiert oder bedingt ausgeblendet',
  aiTeammateWidget_defaultButton: 'KI-Teammate starten',
  aiTeammateWidget_starting: 'Wird gestartet...',
  aiTeammateWidget_stopListening: 'Aufnahme stoppen',
  aiTeammateWidget_listening: 'Hört zu...',
  aiTeammateWidget_headerListening: 'Hört zu',
  aiTeammateWidget_extractedInformation: 'Extrahierte Informationen:',
  aiTeammateWidget_noAnswer: 'Keine Antwort',
  aiTeammateWidget_uncertain: '(unsicher)',
  aiTeammateWidget_uncertain_ignored: '(ignoriert: zu unsicher)',
  aiTeammateWidget_option: 'Option',
  aiTeammateWidget_timeoutReached: 'Sicherheitszeitlimit erreicht. Aufnahme automatisch gestoppt.',
  aiTeammateWidget_audioUnavailable: 'Der Audiostream ist nicht mehr verfügbar.',
  aiTeammateWidget_connectionLost:
    'Verbindung verloren. Bitte überprüfen Sie Ihre Netzwerkverbindung und starten Sie KI-Teammate erneut.',
  aiTeammateWidget_clearLog: 'Protokoll löschen',
  aiTeammateWidget_question: 'Frage',
  aiTeammateWidget_appConnected: 'App verbunden',
  aiTeammateWidget_transcript: 'Transkript',
  aiTeammateWidget_noTranscript: 'Noch kein Transkript...',
  emailValidationError: 'Ungültige E-Mail-Adresse',
  addSectionsText: 'Fügen Sie Abschnitte hinzu, um Ihr Playbook zu organisieren',
  dropdownPlaceholder: 'Wählen Sie eine Option',
  dropdownNoItemsFound: 'Keine Elemente gefunden',
  clear: 'Löschen',
  formula_error_syntax: 'Unvollständige oder ungültige Formelstruktur (Operatoren/Klammern).',
  formula_error_missing_var: 'Die Formel enthält Variablen, die nicht mehr verfügbar sind.',
  formula_error_empty: 'Keine Formel definiert.',
  formula_error_unknown: 'Bei der Berechnung ist ein Fehler aufgetreten.',
  codeSnippetWidget_defaultButton: 'Code-Snippet',
  createCrmObjectWidget_defaultButton: 'Erstellen',
  genericAiWidget_defaultButton: 'Generieren',
  setTagWidget_defaultButton: 'Weiter',
  updateWithAiWidget_defaultButton: 'Aktualisieren',
  chartNotSupportedMessage: 'Diese Action Cards unterstützt keine Bewertungsdimensionen zur Anzeige eines Diagramms',
  chartTotalScoreLabel: 'Gewichtete Punktzahl',
  lastSlideTitle: 'Ende',
}

export default {
  en,
  de,
}
